import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './OrderSummary.css';

function OrderSummary() {
  const location = useLocation();
  const { orderData } = location.state || {}; // Get orderData from the state
  const shippingCharges = 200;

  // If no order data exists, show a message
  if (!orderData) {
    return <div className="no-order-data">No order data found</div>;
  }

  // Destructure the orderData to access the order details
  const { name, email, phone, address, products, totalAmount, paymentMethod } = orderData;

  // Function to create the WhatsApp message
  const createWhatsAppMessage = () => {
    let message = `Hello, I would like to place an order with the following items:_\n\n`;

    products.forEach((product) => {
      const { name, size, quantity, price } = product;
      let adjustedPrice = price;

      if (size === "Unstitched") {
        adjustedPrice = price - 1000;
      }

      message += `> Title: ${name}\n> Price: PKR ${adjustedPrice}\n> Size: ${size}\n> Quantity: ${quantity}\n> Total: PKR ${adjustedPrice * quantity}\n\n`;
    });

    message += `Subtotal: PKR ${totalAmount}  \nShipping: PKR 200\nTotal: PKR ${totalAmount + 200}\n\n`;

    message += `*Shipping Detail:*\nName: ${name} \nEmail: ${email}\nPhone: ${phone}\nShipping Address: ${address}\n\n`;
    message += `Payment Method: Cash on Delivery (COD)\n\n`;
    message += `Please confirm the order.`;

    return encodeURIComponent(message); // Ensure the message is URL-encoded
  };

  // WhatsApp URL to send the message
  const whatsappURL = `https://wa.me/+923203218800?text=${createWhatsAppMessage()}`;

  return (
    <div>
      {/* Thank You Section */}
      <div className="thank-you-section">
        <h2>Thank You!</h2>
        <p> Your order has been placed successfully</p>
      </div>
      <div className="order-summary-container">
        <h1 className="order-summary-title">Order Summary</h1>

        <div className="shipping-info">
          <h2 className="section-title">Shipping Information</h2>
          <hr className="section-line" /> {/* Full width line */}
          <p className="shipping-detail">Name: {name}</p>
          <p className="shipping-detail">Email: {email}</p>
          <p className="shipping-detail">Phone: {phone}</p>
          <p className="shipping-detail">Shipping Address: {address}</p>
        </div>

        <div className="order-details">
          <h2 className="section-title">Order Details</h2>
          <hr className="section-line" /> {/* Full width line */}
          <ul className="product-list">
            {products.map((product, index) => (
              <li className="product-item" key={index}>
                <span className="product-name"> {product.name}</span>
                <span className="product-size">Size: {product.size}</span>
                <span className="product-quantity">Qty: {product.quantity}</span>
                <span className="product-price">Pkr {product.price}/-</span>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <div className="subtotal">
            <p>Subtotal</p>
            <p>PKR {totalAmount}</p>
          </div>
          <hr />
          <div className="shipping-charges">
            <p>Shipping Charges</p>
            <p>{shippingCharges}</p>
          </div>
          <hr />
          <div className="total">
            <h3>Total</h3>
            <h3>Pkr {totalAmount + shippingCharges}</h3>
          </div>
        </div>

        <div className="payment-method">
          <h2 className="payment-h2">Payment Method</h2>
          <p className="payment-method-value">{paymentMethod}</p> 
        </div>
      </div>

      {/* WhatsApp button with the order details */}
      <div className="whatsapp-message">
      <a
          href={whatsappURL}
          target="_blank"
          rel="noopener noreferrer"
          className="whatsapp-button">
              Continue to chat
      </a>

        <Link 
            className="whatsapp-button"
            to="/">Shop More
        </Link>
        
        
      </div>
    </div>
  );
}

export default OrderSummary;
